var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"centered-box mx-auto mx-lg-0 mx-xl-auto"},[_c('v-img',{staticClass:"mx-auto mb-12",attrs:{"src":require('@/modules/Layout/assets/logo.svg'),"width":_vm.logoWidth,"contain":""}}),(_vm.title)?_c('div',{staticClass:"text-h4 pt-3 pb-6"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }